import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var fieldTemplate = {
  fieldName: '',
  fieldDesc: '',
  fieldType: '',
  dataType: '',
  fieldJson: '',
  columnName: '',
  dataTypeLong: '',
  comment: '',
  fieldSearchType: '',
  dictType: ''
};
import FieldDialog from '@/view/systemTools/autoCode/component/fieldDialog.vue';
import PreviewCodeDialg from '@/view/systemTools/autoCode/component/previewCodeDialg.vue';
import { toUpperCase, toHump, toSQLLine } from '@/utils/stringFun';
import { createTemp, getDB, getTable as _getTable, getColumn as _getColumn, preview, getMeta } from '@/api/autoCode';
import { getDict } from '@/utils/dictionary';
export default {
  name: 'AutoCode',
  components: {
    FieldDialog: FieldDialog,
    PreviewCodeDialg: PreviewCodeDialg
  },
  data: function data() {
    return {
      activeNames: [''],
      preViewCode: {},
      dbform: {
        dbName: '',
        tableName: ''
      },
      dbOptions: [],
      tableOptions: [],
      addFlag: '',
      fdMap: {},
      form: {
        structName: '',
        tableName: '',
        packageName: '',
        abbreviation: '',
        description: '',
        autoCreateApiToSql: false,
        autoMoveFile: false,
        fields: []
      },
      rules: {
        structName: [{
          required: true,
          message: '请输入结构体名称',
          trigger: 'blur'
        }],
        abbreviation: [{
          required: true,
          message: '请输入结构体简称',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          message: '请输入结构体描述',
          trigger: 'blur'
        }],
        packageName: [{
          required: true,
          message: '文件名称：sysXxxxXxxx',
          trigger: 'blur'
        }]
      },
      dialogMiddle: {},
      bk: {},
      dialogFlag: false,
      previewFlag: false
    };
  },
  created: function created() {
    this.getDb();
    this.setFdMap();
    var id = this.$route.params.id;
    if (id) {
      this.getAutoCodeJson(id);
    }
  },
  methods: {
    editAndAddField: function editAndAddField(item) {
      this.dialogFlag = true;
      if (item) {
        this.addFlag = 'edit';
        this.bk = JSON.parse(JSON.stringify(item));
        this.dialogMiddle = item;
      } else {
        this.addFlag = 'add';
        this.dialogMiddle = JSON.parse(JSON.stringify(fieldTemplate));
      }
    },
    moveUpField: function moveUpField(index) {
      if (index === 0) {
        return;
      }
      var oldUpField = this.form.fields[index - 1];
      this.form.fields.splice(index - 1, 1);
      this.form.fields.splice(index, 0, oldUpField);
    },
    moveDownField: function moveDownField(index) {
      var fCount = this.form.fields.length;
      if (index === fCount - 1) {
        return;
      }
      var oldDownField = this.form.fields[index + 1];
      this.form.fields.splice(index + 1, 1);
      this.form.fields.splice(index, 0, oldDownField);
    },
    enterDialog: function enterDialog() {
      var _this = this;
      this.$refs.fieldDialog.$refs.fieldDialogFrom.validate(function (valid) {
        if (valid) {
          _this.dialogMiddle.fieldName = toUpperCase(_this.dialogMiddle.fieldName);
          if (_this.addFlag === 'add') {
            _this.form.fields.push(_this.dialogMiddle);
          }
          _this.dialogFlag = false;
        } else {
          return false;
        }
      });
    },
    closeDialog: function closeDialog() {
      if (this.addFlag === 'edit') {
        this.dialogMiddle = this.bk;
      }
      this.dialogFlag = false;
    },
    deleteField: function deleteField(index) {
      this.form.fields.splice(index, 1);
    },
    enterForm: function enterForm(isPreview) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this2.form.fields.length <= 0)) {
                _context2.next = 1;
                break;
              }
              _this2.$message({
                type: 'error',
                message: '请填写至少一个field'
              });
              return _context2.abrupt("return", false);
            case 1:
              if (!_this2.form.fields.some(function (item) {
                return item.fieldName === _this2.form.structName;
              })) {
                _context2.next = 2;
                break;
              }
              _this2.$message({
                type: 'error',
                message: '存在与结构体同名的字段'
              });
              return _context2.abrupt("return", false);
            case 2:
              _this2.$refs.autoCodeForm.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
                  var data, _data$headers, _data, blob, fileName, url, link;
                  return regeneratorRuntime.wrap(function (_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!valid) {
                          _context.next = 8;
                          break;
                        }
                        _this2.form.structName = toUpperCase(_this2.form.structName);
                        if (!(_this2.form.structName === _this2.form.abbreviation)) {
                          _context.next = 1;
                          break;
                        }
                        _this2.$message({
                          type: 'error',
                          message: 'structName和struct简称不能相同'
                        });
                        return _context.abrupt("return", false);
                      case 1:
                        _this2.form.humpPackageName = toSQLLine(_this2.form.packageName);
                        if (!isPreview) {
                          _context.next = 3;
                          break;
                        }
                        _context.next = 2;
                        return preview(_this2.form);
                      case 2:
                        data = _context.sent;
                        _this2.preViewCode = data.data.autoCode;
                        _this2.previewFlag = true;
                        _context.next = 7;
                        break;
                      case 3:
                        _context.next = 4;
                        return createTemp(_this2.form);
                      case 4:
                        _data = _context.sent;
                        if (!(((_data$headers = _data.headers) === null || _data$headers === void 0 ? void 0 : _data$headers.success) === 'false')) {
                          _context.next = 5;
                          break;
                        }
                        return _context.abrupt("return");
                      case 5:
                        _this2.$message({
                          type: 'success',
                          message: '自动化代码创建成功，正在下载'
                        });
                      case 6:
                        blob = new Blob([_data]);
                        fileName = 'ginvueadmin.zip';
                        if ('download' in document.createElement('a')) {
                          // 不是IE浏览器
                          url = window.URL.createObjectURL(blob);
                          link = document.createElement('a');
                          link.style.display = 'none';
                          link.href = url;
                          link.setAttribute('download', fileName);
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link); // 下载完成移除元素
                          window.URL.revokeObjectURL(url); // 释放掉blob对象
                        } else {
                          // IE 10+
                          window.navigator.msSaveBlob(blob, fileName);
                        }
                      case 7:
                        _context.next = 9;
                        break;
                      case 8:
                        return _context.abrupt("return", false);
                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getDb: function getDb() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return getDB();
            case 1:
              res = _context3.sent;
              if (res.code === 0) {
                _this3.dbOptions = res.data.dbs;
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getTable: function getTable() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return _getTable({
                dbName: _this4.dbform.dbName
              });
            case 1:
              res = _context4.sent;
              if (res.code === 0) {
                _this4.tableOptions = res.data.tables;
              }
              _this4.dbform.tableName = '';
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getColumn: function getColumn() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var gormModelList, res, tbHump;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              gormModelList = ['id', 'created_at', 'updated_at', 'deleted_at'];
              _context5.next = 1;
              return _getColumn(_this5.dbform);
            case 1:
              res = _context5.sent;
              if (res.code === 0) {
                tbHump = toHump(_this5.dbform.tableName);
                _this5.form.structName = toUpperCase(tbHump);
                _this5.form.tableName = _this5.dbform.tableName;
                _this5.form.packageName = tbHump;
                _this5.form.abbreviation = tbHump;
                _this5.form.description = tbHump + '表';
                _this5.form.autoCreateApiToSql = true;
                _this5.form.fields = [];
                res.data.columns && res.data.columns.map(function (item) {
                  if (!gormModelList.some(function (gormfd) {
                    return gormfd === item.columnName;
                  })) {
                    var fbHump = toHump(item.columnName);
                    _this5.form.fields.push({
                      fieldName: toUpperCase(fbHump),
                      fieldDesc: item.columnComment || fbHump + '字段',
                      fieldType: _this5.fdMap[item.dataType],
                      dataType: item.dataType,
                      fieldJson: fbHump,
                      dataTypeLong: item.dataTypeLong,
                      columnName: item.columnName,
                      comment: item.columnComment,
                      fieldSearchType: '',
                      dictType: ''
                    });
                  }
                });
              }
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    setFdMap: function setFdMap() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var fdTypes;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              fdTypes = ['string', 'int', 'bool', 'float64', 'time.Time'];
              fdTypes.map(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(fdtype) {
                  var res;
                  return regeneratorRuntime.wrap(function (_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 1;
                        return getDict(fdtype);
                      case 1:
                        res = _context6.sent;
                        res && res.map(function (item) {
                          _this6.fdMap[item.label] = fdtype;
                        });
                      case 2:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getAutoCodeJson: function getAutoCodeJson(id) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 1;
              return getMeta({
                id: Number(id)
              });
            case 1:
              res = _context8.sent;
              if (res.code === 0) {
                _this7.form = JSON.parse(res.data.meta);
              }
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    }
  }
};